import { action } from '@ember/object';
import SettingsDepartmentsBaseController from '../base';

export default class SettingsDepartmentsDepartmentEditController extends SettingsDepartmentsBaseController {
  @action
  cancel() {
    // Rollback changes to avoid persisting unsaved changes
    this.model.rollbackAttributes();
    this.goToListPage();
  }
}
